import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:itemId?',
	query: [],
};
